// extracted by mini-css-extract-plugin
module.exports = {"link":"ChatBell_link__1RJag","count":"ChatBell_count__2js3D","activeLink":"ChatBell_activeLink__3u_vh","Icon":"ChatBell_Icon__1ueTI"};